import { useEffect, useState } from "react";
import { debounce, isEqual } from "lodash-es";

const useDebouncedState = <T>(value: T, delay: number): T => {
  const [state, setState] = useState<T>(value);

  useEffect(() => {
    if (isEqual(value, state)) return;
    const handler = debounce(() => {
      setState(value);
    }, delay);

    handler();

    return () => {
      handler.cancel();
    };
  }, [value, delay, state]);

  return state;
};

export default useDebouncedState;
